var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"barchart-drilldown-wrapper"},[(_vm.chart_config)?_c('dynamic-chart-component',{attrs:{"el":"barchart-tes-001","config":_vm.chart_config}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }